import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuthApiBase } from "../utils/getApiBase";

export default function LoginScreen() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const API = getAuthApiBase();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // console.log("📡 Using API:", API);
    // console.log("📝 Login payload:", form);

    try {
        const res = await fetch(`${API}/accounts/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
        });

        // console.log("📨 Raw response:", res);

        const data = await res.json().catch(() => null);
        // console.log("📦 Parsed JSON:", data);

        if (!res.ok) {
        // console.log("❌ Login failed. Status:", res.status);
        throw new Error(data?.detail || "Invalid login");
        }

        // console.log("✅ Login SUCCESS:", data);

        localStorage.setItem("access_token", data.access);
        localStorage.setItem("refresh_token", data.refresh);

        navigate("/activate", { replace: true });
    } catch (err) {
        console.error("🔥 LOGIN ERROR:", err);
        alert("Login failed.");
    } finally {
        setLoading(false);
    }
    };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-cream-color px-6">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8 border border-light-gray">
        <h1 className="text-2xl font-primary text-charcoal text-center mb-6">
          Welcome Back
        </h1>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block mb-1 text-charcoal text-sm font-forms">
              Email
            </label>
            <input
              name="email"
              type="email"
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-light-gray rounded-md bg-very-light-gray focus:ring-rich-gold focus:border-rich-gold font-forms"
            />
          </div>

          <div>
            <label className="block mb-1 text-charcoal text-sm font-forms">
              Password
            </label>
            <input
              name="password"
              type="password"
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-light-gray rounded-md bg-very-light-gray focus:ring-rich-gold focus:border-rich-gold font-forms"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-dominant-purple text-white py-3 rounded-md font-action text-sm hover:bg-dark-purple transition"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <p className="mt-4 text-center text-sm text-charcoal">
          New here?{" "}
          <span
            onClick={() => navigate("/register")}
            className="text-rich-gold font-semibold underline cursor-pointer"
          >
            Create account
          </span>
        </p>
      </div>
    </div>
  );
}